"use strict";
/**
 * Redux store for generic Java Lab state.
 */
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsCaptchaDialogOpen = exports.setHasRunOrTestedCode = exports.setValidationPassed = exports.setCommitSaveStatus = exports.setHasOpenCodeReview = exports.setIsReadOnlyWorkspace = exports.setIsJavabuilderConnecting = exports.setLevelName = exports.setIsStartMode = exports.setBackpackEnabled = exports.setIsTesting = exports.setIsRunning = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    isRunning: false,
    isTesting: false,
    backpackEnabled: false,
    isStartMode: false,
    levelName: undefined,
    isReadOnlyWorkspace: false,
    hasOpenCodeReview: false,
    isCommitSaveInProgress: false,
    hasCommitSaveError: false,
    validationPassed: false,
    hasRunOrTestedCode: false,
    isJavabuilderConnecting: false,
    isCaptchaDialogOpen: false,
};
var javalabSlice = (0, toolkit_1.createSlice)({
    name: 'javalab',
    initialState: initialState,
    reducers: {
        setIsRunning: function (state, action) {
            state.isRunning = action.payload;
        },
        setIsTesting: function (state, action) {
            state.isTesting = action.payload;
        },
        setBackpackEnabled: function (state, action) {
            state.backpackEnabled = action.payload;
        },
        /**
         * We should move isStartMode and levelName into a separate level redux file,
         * or convert this design to one more closely matching redux/applab. When we
         * do, we can remove the special treatment of Javalab in ImagePicker.jsx that
         * enables the Asset Manager to run.
         */
        setIsStartMode: function (state, action) {
            state.isStartMode = action.payload;
        },
        setLevelName: function (state, action) {
            state.levelName = action.payload;
        },
        setIsJavabuilderConnecting: function (state, action) {
            state.isJavabuilderConnecting = action.payload;
        },
        setIsReadOnlyWorkspace: function (state, action) {
            state.isReadOnlyWorkspace = action.payload;
        },
        setHasOpenCodeReview: function (state, action) {
            state.hasOpenCodeReview = action.payload;
        },
        setCommitSaveStatus: function (state, action) {
            state.isCommitSaveInProgress = action.payload.isCommitSaveInProgress;
            state.hasCommitSaveError = action.payload.hasCommitSaveError;
        },
        setValidationPassed: function (state, action) {
            state.validationPassed = action.payload;
        },
        setHasRunOrTestedCode: function (state, action) {
            state.hasRunOrTestedCode = action.payload;
        },
        setIsCaptchaDialogOpen: function (state, action) {
            state.isCaptchaDialogOpen = action.payload;
        },
    },
});
exports.setIsRunning = (_a = javalabSlice.actions, _a.setIsRunning), exports.setIsTesting = _a.setIsTesting, exports.setBackpackEnabled = _a.setBackpackEnabled, exports.setIsStartMode = _a.setIsStartMode, exports.setLevelName = _a.setLevelName, exports.setIsJavabuilderConnecting = _a.setIsJavabuilderConnecting, exports.setIsReadOnlyWorkspace = _a.setIsReadOnlyWorkspace, exports.setHasOpenCodeReview = _a.setHasOpenCodeReview, exports.setCommitSaveStatus = _a.setCommitSaveStatus, exports.setValidationPassed = _a.setValidationPassed, exports.setHasRunOrTestedCode = _a.setHasRunOrTestedCode, exports.setIsCaptchaDialogOpen = _a.setIsCaptchaDialogOpen;
exports.default = javalabSlice.reducer;
